/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Piggy: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M16.5 6.99988H8.617C7.546 5.17388 5.739 4.89088 4.858 5.00988L3.718 5.17288L4.746 8.70188C3.975 9.33488 3.339 10.1129 2.872 10.9999H0V17.9999H2.866C4.079 20.3029 6.395 21.7929 9 21.9659V23.9999H11V21.9999H15V23.9999H17V21.9749C20.902 21.7159 24 18.4669 24 14.4999C24 10.3639 20.636 6.99988 16.5 6.99988ZM17 12.9999H10V10.9999H17V12.9999Z'
      fill='currentColor'
    />
    <path d='M13.5 5C14.8807 5 16 3.88071 16 2.5C16 1.11929 14.8807 0 13.5 0C12.1193 0 11 1.11929 11 2.5C11 3.88071 12.1193 5 13.5 5Z' fill='currentColor' />
  </React.Fragment>
)
